export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";